export const SHOPIFY_INVOICE_EMAIL_TEMPLATE =
`
<!DOCTYPE html>
<html lang="en">
{% if payment_terms.type == 'fulfillment' and payment_terms.next_payment.due_at == nil %}
  {% assign due_on_fulfilllment_terms = true %}
{% else %}
  {% assign due_on_fulfilllment_terms = false %}
{% endif %}
{% if source_name == 'shopify_draft_order' and financial_status == 'pending' %}
  {% assign order_from_draft = true %}
{% else %}
  {% assign order_from_draft = false %}
{% endif %}
<head>
  <title>{{ email_title }}</title>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
  <meta name="viewport" content="width=device-width">
  <link rel="stylesheet" type="text/css" href="/assets/notifications/styles.css">
  <style>
    .button__cell { background: {{ shop.email_accent_color }}; }
    a, a:hover, a:active, a:visited { color: {{ shop.email_accent_color }}; }
  </style>
</head>

<body>
<table class="body">
  <tr>
    <td>
      <table class="header row">
  <tr>
    <td class="header__cell">
      <center>

        <table class="container">
          <tr>
            <td>

              <table class="row">
                <tr>
                  <td class="shop-name__cell">
                    {%- if shop.email_logo_url %}
                      <img src="{{shop.email_logo_url}}" alt="{{ shop.name }}" width="{{ shop.email_logo_width }}">
                    {%- else %}
                      <h1 class="shop-name__text">
                        <a href="{{shop.url}}">{{ shop.name }}</a>
                      </h1>
                    {%- endif %}
                  </td>

                    <td>
                      <table class="order-po-number__container">
                        <tr>
                          <td class="order-number__cell">
                            <span class="order-number__text">
                              Invoice {{ order_name }}
                            </span>
                          </td>
                        </tr>
                        {%- if po_number %}
                            <tr>
                              <td class="po-number__cell">
                                <span class="po-number__text">
                                  PO number #{{ po_number }}
                                </span>
                              </td>
                            </tr>
                        {%- endif %}
                      </table>
                    </td>
                </tr>
              </table>

            </td>
          </tr>
        </table>

      </center>
    </td>
  </tr>
</table>

      <table class="row content">
  <tr>
    <td class="content__cell">
      <center>
        <table class="container">
          <tr>
            <td>
              
        {% if payment_terms.type == 'receipt' and payment_terms.next_payment.due_at == nil %}
          {% assign due_date = 'now' %}
        {% else %}
          {% assign due_date = payment_terms.next_payment.due_at | default: nil %}
        {% endif %}

        {% if due_on_fulfilllment_terms == true and payment_terms.automatic_capture_at_fulfillment == false or payment_terms.automatic_capture_at_fulfillment == true and order_from_draft == true %}
          <h2>Payment of {{ order.total_outstanding | money }} is due on fulfillment</h2>
        {% else %}
          <h2>Payment of {{ order.total_outstanding | money }} is due {{ due_date | date: format: 'date' }}</h2>
        {% endif %}
        {% if custom_message != blank %}
        <p>{{ custom_message }}</p>
        {% endif %}
        {% if checkout_payment_collection_url and (financial_status == 'partially_paid' or financial_status == 'partially_refunded') and attributes.streamlined_invoice_url == blank %}
        <table class="row actions">
          <tr>
            <td class="actions__cell">
              <table class="button main-action-cell">
                <tr>
                  <td class="button__cell"><a href="{{ checkout_payment_collection_url }}" class="button__text">Pay now</a></td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        {% endif %}
        {% if attributes.streamlined_invoice_url %}
        <table class="row actions">
          <tr>
            <td class="actions__cell">
              <table class="button main-action-cell">
                <tr>
                  <td class="button__cell"><a href="{{ attributes.streamlined_invoice_url }}" class="button__text">Pay now</a></td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        {% endif %}
            </td>
          </tr>
        </table>
      </center>
    </td>
  </tr>
</table>

      <table class="row section">
  <tr>
    <td class="section__cell">
      <center>
        <table class="container">
          <tr>
            <td>
              <h3>Order summary</h3>
            </td>
          </tr>
        </table>
        <table class="container">
          <tr>
            <td>
              
        {% if line_items_including_zero_quantity == empty or grouped_view == true %}
          
  
<table class="row">
  {% for line in subtotal_line_items %}
    {% if line.groups.size == 0 %}
      
{% comment %} Skip child add-ons since they will be rendered under the parent line item {% endcomment %}
{% unless line.nested_line_child? %}

  {% assign is_parent = false %}
  {% assign is_nested_line_parent = line.nested_line_parent? %}
  {% if line.bundle_parent? or line.nested_line_parent? %}
    {% assign is_parent = true %}
  {% endif %}
  {% if is_nested_line_parent %}
    {% assign css_order_list_cell_nested_line_parent_class = 'order-list__parent-cell' %}
    {% assign css_order_list_parent_image_cell_nested_line_parent_class = 'order-list__nested-parent-image-cell' %}
  {% endif %}

  <tr class="order-list__item">
    <td class="order-list__item__cell {{ css_order_list_cell_nested_line_parent_class }}">
      <table height="100%">
        <td style="padding-bottom: 0px;">
          <table height="100%">
            <tr valign="top">
              {% if false and is_parent %}
                <td class="order-list__parent-image-cell {{ css_order_list_parent_image_cell_nested_line_parent_class }}">
                  {% if line.image %}
                    <img src="{{ line | img_url: 'compact_cropped' }}" align="left" width="60" height="60" class="order-list__product-image"/>
                  {% else %}
                    <div class="order-list__no-image-cell">
                      <img src="{{ 'notifications/no-image.png' | shopify_asset_url }}" align="left" class="order-list__no-product-image"/>
                    </div>
                  {% endif %}
                </td>
              {% else %}
                <td class="order-list__image-cell">
                  {% if line.image %}
                    <img src="{{ line | img_url: 'compact_cropped' }}" align="left" width="60" height="60" class="order-list__product-image"/>
                  {% else %}
                    <div class="order-list__no-image-cell">
                      <img src="{{ 'notifications/no-image.png' | shopify_asset_url }}" align="left" width="60" height="60" class="order-list__no-product-image"/>
                    </div>
                  {% endif %}
                </td>
              {% endif %}
            </tr>
            {% if is_nested_line_parent %}
              <tr height="100%">
                <td style="padding: 0px;" height="100%">
                  <table height="100%">
                    <tr>
                      <td height="100%" class="nested-line-item-spacer-cell">
                        <div class="nested-line-item-spacer"></div>
                      </td>
                      <td height="100%" class="parent-vertical-line__cell">
                        <div class="parent-vertical-line__content"></div>
                      </td>
                    </tr>
                  </table>                        
                </td>
              </tr>
            {% endif %}
          </table>
        </td>

        <td class="order-list__product-description-cell">
          {% if line.presentment_title %}
            {% assign line_title = line.presentment_title %}
          {% elsif line.title %}
            {% assign line_title = line.title %}
          {% else %}
            {% assign line_title = line.product.title %}
          {% endif %}
          {% if line.quantity < line.quantity %}
            {% capture line_display %}
              {{ line.quantity }} of {{ line.quantity }}
            {% endcapture %}
          {% else %}
            {% assign line_display = line.quantity %}
          {% endif %}

          <span class="order-list__item-title">{{ line_title }}&nbsp;&times;&nbsp;{{ line_display }}</span><br/>

          {% if line.variant.title != 'Default Title' and is_parent == false %}
            <span class="order-list__item-variant">{{ line.variant.title }}</span><br/>
          {% elsif line.variant.title != 'Default Title' and line.nested_line_parent? %}
            <span class="order-list__item-variant">{{ line.variant.title }}</span><br/>
          {% elsif line.variant.title != 'Default Title' and line.bundle_parent? and false == false %}
            <span class="order-list__item-variant">{{ line.variant.title }}</span><br/>
          {% endif %}

          {% if false %}
            {% for child_line in line.bundle_components %}
              
{% if true %}
  {% assign css_class = 'order-list__bundle-item' %}
  {% assign css_image_class = 'order-list__image-cell' %}
  {% assign css_description_class = 'order-list__product-description-cell' %}
{% else %}
  {% assign css_class = 'order-list__deliverable-item_abandoned' %}
  {% assign css_image_class = 'order-list__image-cell--nested-line-item' %}
  {% assign css_description_class = 'order-list__product-description-cell--nested-line-item' %}
  {% if false %}
    {% assign css_curved_line_cell_container_class = 'curved-line-cell-container__top-spacer-cell--show-border' %}
    {% assign css_hide_vertical_line_class = 'vertical-line__content--hide' %}
    {% assign css_curved_line_cell_container_cell__no_padding_class = 'curved-line-cell-container__cell--no-padding' %}
  {% endif %}
{% endif %}

<table height="100%">
  <tr class="order-list__item">
    <td class="{{ css_class }}" height="100%">
      <table height="100%">
        <td class="{{ css_image_class }}">
          {% if child_line.image %}
            <img src="{{ child_line | img_url: 'compact_cropped' }}" align="left" width="40" height="40" class="order-list__product-image small"/>
          {% else %}
            <div class="order-list__no-image-cell small">
              <img src="{{ 'notifications/no-image.png' | shopify_asset_url }}" align="left" width="20" height="20" class="order-list__no-product-image small"/>
            </div>
          {% endif %}
        </td>

        <td class="{{ css_description_class }}">
          {% if child_line.product.title %}
            {% assign item_title = child_line.product.title %}
          {% else %}
            {% assign item_title = child_line.title %}
          {% endif %}

          {% assign item_display = child_line.quantity %}

            <span class="order-list__item-title">{{ item_display }}&nbsp;&times;&nbsp;{{ item_title }}</span><br>

          {% if child_line.variant.title != 'Default Title'%}
            <span class="order-list__item-variant">{{ child_line.variant.title }}</span>
          {% endif %}
        </td>
      </table>
    </td>
  </tr>
</table>
            {% endfor %}
          {% else %}
            {% for group in line.groups %}
              {% if group.deliverable? %}
                <span class="order-list__item-variant">For: {{ group.display_title }}</span><br/>
              {% else %}
                <span class="order-list__item-variant">Part of: {{ group.display_title }}</span><br/>
              {% endif %}
            {% endfor %}
          {% endif %}

            {% if line.gift_card and line.properties["__shopify_send_gift_card_to_recipient"] %}
              {% for property in line.properties %}
  {% assign property_first_char = property.first | slice: 0 %}
  {% if property.last != blank and property_first_char != '_' %}
    <div class="order-list__item-property">
      <dt>{{ property.first }}:</dt>
      <dd>
      {% if property.last contains '/uploads/' %}
        <a href="{{ property.last }}" class="link" target="_blank">
        {{ property.last | split: '/' | last }}
        </a>
      {% else %}
        {{ property.last }}
      {% endif %}
      </dd>
    </div>
  {% endif %}
{% endfor %}

            {% endif %}

          {% if line.selling_plan_allocation %}
            <span class="order-list__item-variant">{{ line.selling_plan_allocation.selling_plan.name }}</span><br/>
          {% endif %}

          {% if line.refunded_quantity > 0 %}
            <span class="order-list__item-refunded">Refunded</span>
          {% endif %}

          {% if line.discount_allocations %}
            {% for discount_allocation in line.discount_allocations %}
              {% if discount_allocation.discount_application.target_selection != 'all' %}
              <p>
                <span class="order-list__item-discount-allocation">
                  <img src="{{ 'notifications/discounttag.png' | shopify_asset_url }}" width="18" height="18" class="discount-tag-icon" />
                  <span>
                    {{ discount_allocation.discount_application.title | upcase }}
                    (-{{ discount_allocation.amount | money }})
                  </span>
                </span>
              </p>
              {% endif %}
            {% endfor %}
          {% endif %}
        </td>
          {% if false and is_parent %}
            <td class="order-list__parent-price-cell">
          {% else %}
            <td class="order-list__price-cell">
          {% endif %}
          {% if line.original_line_price != line.final_line_price %}
            <del class="order-list__item-original-price">{{ line.original_line_price | money }}</del>
          {% endif %}
            <p class="order-list__item-price">
              {% if line.final_line_price > 0 %}
                {{ line.final_line_price | money }}
                {% if line.unit_price_measurement %}
  <div class="order-list__unit-price">
    {{- line.unit_price | unit_price_with_measurement: line.unit_price_measurement -}}
  </div>
{% endif %}
              {% else %}
                Free
              {% endif %}
            </p>
          </td>
        {% if line.nested_line_parent? %}
          {% for child_line in line.nested_lines %}
            
{% if false %}
  {% assign css_class = 'order-list__bundle-item' %}
  {% assign css_image_class = 'order-list__image-cell' %}
  {% assign css_description_class = 'order-list__product-description-cell' %}
{% else %}
  {% assign css_class = 'order-list__deliverable-item_abandoned' %}
  {% assign css_image_class = 'order-list__image-cell--nested-line-item' %}
  {% assign css_description_class = 'order-list__product-description-cell--nested-line-item' %}
  {% if forloop.last %}
    {% assign css_curved_line_cell_container_class = 'curved-line-cell-container__top-spacer-cell--show-border' %}
    {% assign css_hide_vertical_line_class = 'vertical-line__content--hide' %}
    {% assign css_curved_line_cell_container_cell__no_padding_class = 'curved-line-cell-container__cell--no-padding' %}
  {% endif %}
{% endif %}

<table height="100%">
  <tr class="order-list__item">
    <td class="{{ css_class }}" height="100%">
      <table height="100%">
          <td class="nested-line-item-spacer-cell"style="padding: 1px;">
            <div class="nested-line-item-spacer"></div>
          </td>
          <td class="curved-line-cell-container" valign="top">
            <div style="width: 0px;">
              <table>
                <tr>
                  <td class="{{ css_curved_line_cell_container_cell__no_padding_class }}" style="mso-padding-right-alt: 10px;">
                    <div class="curved-line-cell-container__top-spacer {{ css_curved_line_cell_container_class }}"></div>
                  </td>
                </tr>
                <tr>
                  <td class="curved-line-cell-container__curvedLine-cell">
                    <div class="curved-line-cell-container__curvedLine-cell__curvedLine"></div>
                  </td>
                </tr>
              </table>
            </div>
          </td>
          <td class="vertical-line" height="100%">
            <div class="vertical-line__content {{ css_hide_vertical_line_class }}"></div>
          </td>
          <td class="nested-line-item-spacer-cell--right">
            <div class="nested-line-item-spacer"></div>
          </td>
        <td class="{{ css_image_class }}">
          {% if child_line.image %}
            <img src="{{ child_line | img_url: 'compact_cropped' }}" align="left" width="40" height="40" class="order-list__product-image small"/>
          {% else %}
            <div class="order-list__no-image-cell small">
              <img src="{{ 'notifications/no-image.png' | shopify_asset_url }}" align="left" width="20" height="20" class="order-list__no-product-image small"/>
            </div>
          {% endif %}
        </td>

        <td class="{{ css_description_class }}">
          {% if child_line.product.title %}
            {% assign item_title = child_line.product.title %}
          {% else %}
            {% assign item_title = child_line.title %}
          {% endif %}

          {% assign item_display = child_line.quantity %}

            <span class="order-list__item-title">{{ item_title }}&nbsp;&times;&nbsp;{{ item_display }}</span><br>

          {% if child_line.variant.title != 'Default Title'%}
            <span class="order-list__item-variant">{{ child_line.variant.title }}</span>
          {% endif %}
        </td>
      </table>
    </td>
  </tr>
</table>
          {% endfor %}
        {% endif %}
      </table>
    </td>
  </tr>

{% endunless %}

    {% endif %}
  {% endfor %}
  {% for line_item_group in line_item_groups %}
    
{% assign final_line_price = 0 %}
{% assign original_line_price = 0 %}
{% assign discount_keys_str = "" %}
{% assign parent_line_item = nil %}

{% if line_item_group.deliverable? == false %}
  {% assign line_item_group_class = "order-list__item__cell" %}
  {% for component in line_item_group.components %}
    {% assign final_line_price = final_line_price | plus: component.final_line_price %}
    {% assign original_line_price = original_line_price | plus: component.original_line_price %}

    {% for da in component.discount_allocations %}
      {% if da.discount_application.target_selection != 'all' %}
        {% assign discount_key = da.discount_application.title | append: da.discount_application.type %}
        {% assign discount_keys_str = discount_keys_str | append: discount_key | append: "," %}
      {% endif %}
    {% endfor %}
  {% endfor %}
{% endif %}

{% if line_item_group.deliverable? %}
  {% assign parent_line_item = line_item_group.parent_sales_line_item %}
  {% assign final_line_price = parent_line_item.final_line_price %}
  {% assign original_line_price = parent_line_item.original_line_price %}
  {% assign line_item_group_class = "order-list__parent_item__cell" %}
  {% assign padding_bottom_none_class = "padding-bottom-none" %}
{% endif %}

{% assign discount_keys = discount_keys_str | split: "," | uniq %}

<tr class="order-list__item">
  <td class="{{ line_item_group_class }}" style="padding: 15px 0 0px 1px;">
    <table height="100%">
        <td class="order-list__parent-image-cell">
          <table height="100%">
            <tr>
              <td class="{{ padding_bottom_none_class }}" valign="top">
                {% if parent_line_item and parent_line_item.image %}
                  <img src="{{ parent_line_item | img_url: 'compact_cropped' }}" align="left" width="60" height="60" class="order-list__product-image"/>
                {% elsif line_item_group.image %}
                  <img src="{{ line_item_group | img_url: 'compact_cropped' }}" align="left" width="60" height="60" class="order-list__product-image"/>
                {% else %}
                  <div class="order-list__no-image-cell">
                    <img src="{{ 'notifications/no-image.png' | shopify_asset_url }}" align="left" width="30" height="30" class="order-list__no-product-image"/>
                  </div>
                {% endif %}
              </td>
            </tr>
            {% if line_item_group.deliverable? == true %}
              <tr height="100%">
                <td height="100%" class="parent-vertical-line__cell">
                  <table height="100%" style="width: auto;">
                    <tr>
                      <td height="100%" class="nested-line-item-spacer-cell">
                        <div style="width: 6px;"></div>
                      </td>
                      <td height="100%" class="parent-vertical-line__cell">
                        <div class="parent-vertical-line__content"></div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            {% endif %}
          </table>
        </td>

        <td class="order-list__product-description-cell">
          <table>
            <tr>
              <td class="order-list__product-description-cell" colspan="2">
                <span class="order-list__item-title">{{ line_item_group.display_title }}&nbsp;&times;&nbsp;{{ line_item_group.quantity }}</span><br/>
                {% if line_item_group.variant and line_item_group.variant.title != 'Default Title' %}
                  <span class="order-list__item-variant">{{ line_item_group.variant.title }}</span>
                {% endif %}

                {% if line_item_group.deliverable? %}
                  {% if parent_line_item.discount_allocations %}
                    {% for discount_allocation in parent_line_item.discount_allocations %}
                      {% if discount_allocation.discount_application.target_selection != 'all' %}
                        <p>
                          <span class="order-list__item-discount-allocation">
                            <img src="{{ 'notifications/discounttag.png' | shopify_asset_url }}" width="18" height="18" class="discount-tag-icon" />
                            <span>
                              {{ discount_allocation.discount_application.title | upcase }}
                              (-{{ discount_allocation.amount | money }})
                            </span>
                          </span>
                        </p>
                      {% endif %}
                    {% endfor %}
                  {% endif %}
                {% else %}
                  {% for discount_key in discount_keys %}
                    {% assign discount_amount = 0 %}

                    {% for component in line_item_group.components %}
                      {% for da in component.discount_allocations %}
                        {% assign key = da.discount_application.title | append: da.discount_application.type %}
                        {% if da.discount_application.target_selection != 'all' and key == discount_key %}
                          {% assign discount_amount = discount_amount | plus: da.amount %}
                          {% assign discount_title = da.discount_application.title %}
                        {% endif %}
                      {% endfor %}
                    {% endfor %}

                    <p>
                      <span class="order-list__item-discount-allocation">
                        <img src="{{ 'notifications/discounttag.png' | shopify_asset_url }}" width="18" height="18" class="discount-tag-icon" />
                        <span>
                          {{ discount_title | upcase }}
                          (-{{ discount_amount | money }})
                        </span>
                      </span>
                    </p>
                  {% endfor %}
                {% endif %}
              </td>

                <td class="order-list__parent_price-cell">
                  {% if original_line_price != final_line_price %}
                    <del class="order-list__item-original-price">{{ original_line_price | money }}</del>
                  {% endif %}
                  <p class="order-list__item-price">
                    {% if final_line_price > 0 %}
                      {{ final_line_price | money }}
                    {% else %}
                      {{ 'notifications.views.mailers.notifications.discount_free' | t }}
                    {% endif %}
                  </p>
                </td>
            </tr>

            {% if line_item_group.deliverable? == false %}
              {% for component in line_item_group.components %}
                
{% if true %}
  {% assign order_list_item_class = "order-list__bundle-item" %}
  {% assign css_image_class = 'order-list__image-cell' %}
  {% assign order_list_product_description_class = 'order-list__product-description-cell' %}
{% else %}
  {% assign order_list_product_description_class = 'order-list__product-description-cell--nested-line-item' %}
  {% if false %}
    {% assign css_curved_line_cell_container_class = 'curved-line-cell-container__top-spacer-cell--show-border' %}
    {% assign css_hide_vertical_line_class = 'vertical-line__content--hide' %}
    {% assign css_curved_line_cell_container_cell__no_padding_class = 'curved-line-cell-container__cell--no-padding' %}
  {% endif %}
{% endif %}

<tr height="100%">
    <td class="{{ order_list_item_class }} {{ css_image_class }}" valign="top">
        {% if component.image %}
        <img src="{{ component | img_url: 'compact_cropped' }}" align="left" width="40" height="40" class="order-list__product-image"/>
        {% else %}
        <div class="order-list__no-image-cell small">
            <img src="{{ 'notifications/no-image.png' | shopify_asset_url }}" align="left" width="20" height="20" class="order-list__no-product-image small"/>
        </div>
        {% endif %}
    </td>

    <td class="{{ order_list_product_description_class }}" valign="top">
        {% if component.product.title %}
            {% assign component_title = component.product.title %}
        {% else %}
            {% assign component_title = component.title %}
        {% endif %}

        {% if line_item_group.deliverable? %}
            <span class="order-list__item-title">{{ component_title }}&nbsp;&times;&nbsp;{{ component.quantity }}</span>
        {% else %}
            <span class="order-list__item-title">{{ component.quantity }}&nbsp;&times;&nbsp;{{ component_title }}</span>
        {% endif %}
        <br>
        {% if component.variant.title != 'Default Title' %}
            <span class="order-list__item-variant">{{ component.variant.title }}</span>
        {% endif %}

        {% if line_item_group.deliverable? %}
            {% if component.discount_allocations %}
                {% for discount_allocation in component.discount_allocations %}
                    {% if discount_allocation.discount_application.target_selection != 'all' %}
                        <p>
                            <span class="order-list__item-discount-allocation">
                            <img src="{{ 'notifications/discounttag.png' | shopify_asset_url }}" width="18" height="18" class="discount-tag-icon" />
                            <span>
                                {{ discount_allocation.discount_application.title | upcase }}
                                (-{{ discount_allocation.amount | money }})
                            </span>
                            </span>
                        </p>
                    {% endif %}
                {% endfor %}
            {% endif %}
        {% endif %}
    </td>

    {% if line_item_group.deliverable? %}
    <td class="order-list__price-cell">
        {% if component.original_line_price != component.final_line_price %}
            <del class="order-list__item-original-price">{{ component.original_line_price | money }}</del>
        {% endif %}
        <p class="order-list__item-price">
        {% if component.final_line_price > 0 %}
            {{ component.final_line_price | money }}
        {% else %}
            Free
        {% endif %}
        </p>
    </td>
    {% endif %}
</tr>

              {% endfor %}
            {% endif %}
          </table>
        </td>
    </table>
    {% if line_item_group.deliverable? %}
      <td height="100%">
        {% for component in line_item_group.components %}

          <tr>
            <td class="order-list__deliverable-item" height="100%" style="padding: 0;">
              <table height="100%">
                
{% if false %}
  {% assign order_list_item_class = "order-list__bundle-item" %}
  {% assign css_image_class = 'order-list__image-cell' %}
  {% assign order_list_product_description_class = 'order-list__product-description-cell' %}
{% else %}
  {% assign order_list_product_description_class = 'order-list__product-description-cell--nested-line-item' %}
  {% if forloop.last %}
    {% assign css_curved_line_cell_container_class = 'curved-line-cell-container__top-spacer-cell--show-border' %}
    {% assign css_hide_vertical_line_class = 'vertical-line__content--hide' %}
    {% assign css_curved_line_cell_container_cell__no_padding_class = 'curved-line-cell-container__cell--no-padding' %}
  {% endif %}
{% endif %}

<tr height="100%">
    <td class="nested-line-item-spacer-cell" style="padding: 1px;">
        <div class="nested-line-item-spacer"></div>
    </td>
    <td class="curved-line-cell-container" valign="top">
        <div style="width: 0px;">
            <table>
                <tr>
                    <td class="{{ css_curved_line_cell_container_cell__no_padding_class }}" style="mso-padding-right-alt: 10px;">
                        <div class="curved-line-cell-container__top-spacer {{ css_curved_line_cell_container_class }}"></div>
                    </td>
                </tr>
                <tr>
                    <td class="curved-line-cell-container__curvedLine-cell">
                        <div class="curved-line-cell-container__curvedLine-cell__curvedLine"></div>
                    </td>
                </tr>
            </table>
        </div>
    </td>
    <td class="vertical-line" height="100%">
        <div class="vertical-line__content {{ css_hide_vertical_line_class }}"></div>
    </td>
    <td class="nested-line-item-spacer-cell--right">
        <div class="nested-line-item-spacer"></div>
    </td>
    <td class="{{ order_list_item_class }} {{ css_image_class }}" valign="top">
        {% if component.image %}
        <img src="{{ component | img_url: 'compact_cropped' }}" align="left" width="40" height="40" class="order-list__product-image"/>
        {% else %}
        <div class="order-list__no-image-cell small">
            <img src="{{ 'notifications/no-image.png' | shopify_asset_url }}" align="left" width="20" height="20" class="order-list__no-product-image small"/>
        </div>
        {% endif %}
    </td>

    <td class="{{ order_list_product_description_class }}" valign="top">
        {% if component.product.title %}
            {% assign component_title = component.product.title %}
        {% else %}
            {% assign component_title = component.title %}
        {% endif %}

        {% if line_item_group.deliverable? %}
            <span class="order-list__item-title">{{ component_title }}&nbsp;&times;&nbsp;{{ component.quantity }}</span>
        {% else %}
            <span class="order-list__item-title">{{ component.quantity }}&nbsp;&times;&nbsp;{{ component_title }}</span>
        {% endif %}
        <br>
        {% if component.variant.title != 'Default Title' %}
            <span class="order-list__item-variant">{{ component.variant.title }}</span>
        {% endif %}

        {% if line_item_group.deliverable? %}
            {% if component.discount_allocations %}
                {% for discount_allocation in component.discount_allocations %}
                    {% if discount_allocation.discount_application.target_selection != 'all' %}
                        <p>
                            <span class="order-list__item-discount-allocation">
                            <img src="{{ 'notifications/discounttag.png' | shopify_asset_url }}" width="18" height="18" class="discount-tag-icon" />
                            <span>
                                {{ discount_allocation.discount_application.title | upcase }}
                                (-{{ discount_allocation.amount | money }})
                            </span>
                            </span>
                        </p>
                    {% endif %}
                {% endfor %}
            {% endif %}
        {% endif %}
    </td>

    {% if line_item_group.deliverable? %}
    <td class="order-list__price-cell">
        {% if component.original_line_price != component.final_line_price %}
            <del class="order-list__item-original-price">{{ component.original_line_price | money }}</del>
        {% endif %}
        <p class="order-list__item-price">
        {% if component.final_line_price > 0 %}
            {{ component.final_line_price | money }}
        {% else %}
            Free
        {% endif %}
        </p>
    </td>
    {% endif %}
</tr>

              </table>
            </td>
          </tr>
        {% endfor %}
      </td>
    {% endif %}
  </td>
</tr>

  {% endfor %}
</table>

        {% else %}
          
<table class="row">
  {% for line in line_items_including_zero_quantity %}
  <tr class="order-list__item">
    <td class="order-list__item__cell">
      <table>
          {% assign expand_bundles = false %}
        {% if expand_bundles and line.bundle_parent? %}
          <td class="order-list__parent-image-cell">
            {% if line.image %}
              <img src="{{ line | img_url: 'compact_cropped' }}" align="left" width="60" height="60" class="order-list__product-image"/>
            {% else %}
              <div class="order-list__no-image-cell">
                <img src="{{ 'notifications/no-image.png' | shopify_asset_url }}" align="left" width="60" height="60" class="order-list__no-product-image"/>
              </div>
            {% endif %}
          </td>
        {% else %}
          <td class="order-list__image-cell">
            {% if line.image %}
              <img src="{{ line | img_url: 'compact_cropped' }}" align="left" width="60" height="60" class="order-list__product-image"/>
            {% else %}
              <div class="order-list__no-image-cell">
                <img src="{{ 'notifications/no-image.png' | shopify_asset_url }}" align="left" width="60" height="60" class="order-list__no-product-image"/>
              </div>
            {% endif %}
          </td>
        {% endif %}
        <td class="order-list__product-description-cell">
          {% if line.product.title %}
            {% assign line_title = line.product.title %}
          {% else %}
            {% assign line_title = line.title %}
          {% endif %}

          {% if line.quantity < line.quantity %}
            {% capture line_display %}
              {{ line.quantity }} of {{ line.quantity }}
            {% endcapture %}
          {% else %}
            {% assign line_display = line.quantity  %}
          {% endif %}

          <span class="order-list__item-title">{{ line_title }}&nbsp;&times;&nbsp;{{ line_display }}</span><br/>

          {% if line.variant.title != 'Default Title' and line.bundle_parent? == false %}
            <span class="order-list__item-variant">{{ line.variant.title }}</span><br/>
          {% elsif line.variant.title != 'Default Title' and line.bundle_parent? and expand_bundles == false %}
            <span class="order-list__item-variant">{{ line.variant.title }}</span><br/>
          {% endif %}

          {% if expand_bundles %}
            {% for component in line.bundle_components %}
              <table>
                <tr class="order-list__item">
                  <td class="order-list__bundle-item">
                    <table>
                      <td class="order-list__image-cell">
                        {% if component.image %}
                          <img src="{{ component | img_url: 'compact_cropped' }}" align="left" width="40" height="40" class="order-list__product-image"/>
                        {% else %}
                          <div class="order-list__no-image-cell small">
                            <img src="{{ 'notifications/no-image.png' | shopify_asset_url }}" align="left" width="40" height="40" class="order-list__no-product-image small"/>
                          </div>
                        {% endif %}
                      </td>

                      <td class="order-list__product-description-cell">
                        {% if component.product.title %}
                          {% assign component_title = component.product.title %}
                        {% else %}
                          {% assign component_title = component.title %}
                        {% endif %}

                        {% assign component_display = component.quantity %}

                        <span class="order-list__item-title">{{ component_display }}&nbsp;&times;&nbsp;{{ component_title }}</span><br>

                        {% if component.variant.title != 'Default Title'%}
                          <span class="order-list__item-variant">{{ component.variant.title }}</span>
                        {% endif %}
                      </td>
                    </table>
                  </td>
                </tr>
              </table>
            {% endfor %}
          {% else %}
            {% for group in line.groups %}
              {% if group.deliverable? %}
                <span class="order-list__item-variant">For: {{ group.display_title }}</span><br/>
              {% else %}
                <span class="order-list__item-variant">Part of: {{ group.display_title }}</span><br/>
              {% endif %}
            {% endfor %}
          {% endif %}

            {% if line.gift_card and line.properties["__shopify_send_gift_card_to_recipient"] %}
              {% for property in line.properties %}
  {% assign property_first_char = property.first | slice: 0 %}
  {% if property.last != blank and property_first_char != '_' %}
    <div class="order-list__item-property">
      <dt>{{ property.first }}:</dt>
      <dd>
      {% if property.last contains '/uploads/' %}
        <a href="{{ property.last }}" class="link" target="_blank">
        {{ property.last | split: '/' | last }}
        </a>
      {% else %}
        {{ property.last }}
      {% endif %}
      </dd>
    </div>
  {% endif %}
{% endfor %}

            {% endif %}

          {% if line.selling_plan_allocation %}
            <span class="order-list__item-variant">{{ line.selling_plan_allocation.selling_plan.name }}</span><br/>
          {% endif %}

          {% if line.aggregated_update %}
            <span class="order-list__item-update-status">{{line.aggregated_update}}</span>
          {% elsif line.refunded_quantity > 0 %}
            <span class="order-list__item-refunded">Refunded</span>
          {% endif %}

          {% if line.discount_allocations %}
            {% for discount_allocation in line.discount_allocations %}
              {% if discount_allocation.discount_application.target_selection != 'all' %}
                <p>
                  <span class="order-list__item-discount-allocation">
                    <img src="{{ 'notifications/discounttag.png' | shopify_asset_url }}" width="18" height="18" class="discount-tag-icon" />
                    <span>
                      {{ discount_allocation.discount_application.title | upcase }}
                      (-{{ discount_allocation.amount | money }})
                    </span>
                  </span>
                </p>
              {% endif %}
            {% endfor %}
          {% endif %}
        </td>
          {% if expand_bundles and line.bundle_parent? %}
            <td class="order-list__parent-price-cell">
          {% else %}
            <td class="order-list__price-cell">
          {% endif %}
          {% if line.original_line_price != line.final_line_price %}
            <del class="order-list__item-original-price">{{ line.original_line_price | money }}</del>
          {% endif %}
            <p class="order-list__item-price">
              {% if line.final_line_price > 0 or line.quantity == 0 %}
                {{ line.final_line_price | money }}
                {% if line.unit_price_measurement %}
  <div class="order-list__unit-price">
    {{- line.unit_price | unit_price_with_measurement: line.unit_price_measurement -}}
  </div>
{% endif %}
              {% else %}
                Free
              {% endif %}
            </p>
          </td>
      </table>
    </td>
  </tr>{% endfor %}
</table>

        {% endif %}
        
<table class="row subtotal-lines">
  <tr>
    <td class="subtotal-spacer"></td>
    <td>
      <table class="row subtotal-table">

        
{% assign total_order_discount_amount = 0 %}
{% assign has_shipping_discount = false %}
{% assign epsilon = 0.00001 %}

{% for discount_application in discount_applications %}
  {% if discount_application.target_selection == 'all' and discount_application.target_type == 'line_item' %}
    {% assign order_discount_count = order_discount_count | plus: 1 %}
    {% assign total_order_discount_amount = total_order_discount_amount | plus: discount_application.total_allocated_amount %}
  {% endif %}
  {% if discount_application.target_type == 'shipping_line' %}
    {% assign has_shipping_discount = true %}
    {% assign shipping_discount_title = discount_application.title %}
    {% assign discount_value_price = discount_application.total_allocated_amount %}
    {% assign shipping_amount_minus_discount_value_price = shipping_price | minus: discount_value_price %}
    {% assign shipping_amount_minus_discount_value_price_abs = shipping_amount_minus_discount_value_price | abs %}
    {% assign discount_application_value_type = discount_application.value_type | strip %}
    {% if shipping_amount_minus_discount_value_price_abs < epsilon or discount_application_value_type == 'percentage' and discount_application.value == 100 %}
      {% assign free_shipping = true %}
    {% else %}
      {% assign discounted_shipping_price = shipping_amount_minus_discount_value_price %}
    {% endif %}
  {% endif %}
{% endfor %}


  
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Subtotal</span>
    </p>
  </td>
  <td class="subtotal-line__value">
      <strong>{{ subtotal_price | plus: total_order_discount_amount | money }}</strong>
  </td>
</tr>



{% if order_discount_count > 0 %}
  {% if order_discount_count == 1 %}
    
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Order discount</span>
    </p>
  </td>
  <td class="subtotal-line__value">
      <strong>-{{ total_order_discount_amount | money }}</strong>
  </td>
</tr>

  {% endif %}
  {% if order_discount_count > 1 %}
    
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Order discounts</span>
    </p>
  </td>
  <td class="subtotal-line__value">
      <strong>-{{ total_order_discount_amount | money }}</strong>
  </td>
</tr>

  {% endif %}
  {% for discount_application in discount_applications %}
    {% if discount_application.target_selection == 'all' and discount_application.target_type != 'shipping_line' %}
      <tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span class="subtotal-line__discount">
        <img src="{{ 'notifications/discounttag.png' | shopify_asset_url }}" width="18" height="18" class="discount-tag-icon" />
        <span class="subtotal-line__discount-title">
            {{ discount_application.title }} (-{{ discount_application.total_allocated_amount | money }})
        </span>
      </span>
    </p>
  </td>
</tr>

    {% endif %}
  {% endfor %}
{% endif %}


        
  {% if has_shipping_discount %}
    {% if free_shipping == true %}
      
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Shipping</span>
    </p>
  </td>
  <td class="subtotal-line__value">
    <del>{% if shipping_price != 0 %}{{ shipping_price | money}}{% endif %} </del>
      <strong>Free</strong>
  </td>
</tr>

    {% else %}
      
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Shipping</span>
    </p>
  </td>
  <td class="subtotal-line__value">
    <del>{{ shipping_price | money }} </del>
      <strong>{{ discounted_shipping_price | money }}</strong>
  </td>
</tr>

    {% endif %}
    <tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span class="subtotal-line__discount">
        <img src="{{ 'notifications/discounttag.png' | shopify_asset_url }}" width="18" height="18" class="discount-tag-icon" />
        <span class="subtotal-line__discount-title">
            {{ shipping_discount_title }} 
            {% if discount_value_price != 0 %}
              (-{{ discount_value_price | money }})
            {% endif %}
        </span>
      </span>
    </p>
  </td>
</tr>

  {% else %}
    
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Shipping</span>
    </p>
  </td>
  <td class="subtotal-line__value">
      <strong>{{ shipping_price | money }}</strong>
  </td>
</tr>

  {% endif %}


        {% for fee in fees %}
  
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>{{ fee.title }}</span>
    </p>
  </td>
  <td class="subtotal-line__value">
      <strong>{{ fee.subtotal | money }}</strong>
  </td>
</tr>

{% endfor %}


        {% if total_duties %}
            
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Duties</span>
    </p>
  </td>
  <td class="subtotal-line__value">
      <strong>{{ total_duties | money }}</strong>
  </td>
</tr>

        {% endif %}

          
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Estimated taxes</span>
    </p>
  </td>
  <td class="subtotal-line__value">
      <strong>{{ tax_price | money }}</strong>
  </td>
</tr>


        {% if total_tip_received and total_tip_received > 0 %}
          
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Tip</span>
    </p>
  </td>
  <td class="subtotal-line__value">
      <strong>{{ total_tip_received | money }}</strong>
  </td>
</tr>

        {% endif %}
      </table>
    </td>
  </tr>
</table>

        
<table class="row subtotal-lines">
  <tr>
      {% if total_price > total_outstanding %}
      <td class="subtotal-spacer"></td>
        <td>
          <table class="row subtotal-table">
            
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Updated total</span>
    </p>
  </td>
  <td class="subtotal-line__value">
      <strong>{{ total_price | money }}</strong>
  </td>
</tr>

            
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Already paid</span>
    </p>
  </td>
  <td class="subtotal-line__value">
      <strong>{{ net_payment | money }}</strong>
  </td>
</tr>

          </table>
          <table class="row subtotal-table subtotal-table--total">
            
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Amount to pay</span>
    </p>
  </td>
  <td class="subtotal-line__value">
      <strong>{{ total_outstanding | money_with_currency }}</strong>
  </td>
</tr>

          </table>
        </td>
      {% else %}
        <table class="row subtotal-table subtotal-table--total">
          
<tr class="subtotal-line">
  <td class="subtotal-line__title">
    <p>
      <span>Amount to pay</span>
    </p>
  </td>
  <td class="subtotal-line__value">
      <strong>{{ total_outstanding | money_with_currency }}</strong>
  </td>
</tr>

        </table>
      {% endif %}
  </tr>
</table>

            </td>
          </tr>
        </table>
      </center>
    </td>
  </tr>
</table>

      {% if shipping_address or billing_address or shipping_method or company_location or payment_terms and payment_terms.automatic_capture_at_fulfillment == false %}
      <table class="row section">
  <tr>
    <td class="section__cell">
      <center>
        <table class="container">
          <tr>
            <td>
              <h3>Customer information</h3>
            </td>
          </tr>
        </table>
        <table class="container">
          <tr>
            <td>
              
        <table class="row">
          <tr>
            {% if shipping_address %}
            <td class="customer-info__item">
              <h4>Shipping address</h4>
              {{ shipping_address | format_address }}
            </td>
            {% endif %}

            {% if billing_address %}
            <td class="customer-info__item">
              <h4>Billing address</h4>
              {{ billing_address | format_address }}
            </td>
            {% endif %}
          </tr>
        </table>

        <table class="row">
          <tr>
            {% if company_location %}
              <td class="customer-info__item">
                <h4>Location</h4>
                <p>
                  {{ company_location.name }}
                </p>
              </td>
            {% endif %}

            {% if payment_terms and payment_terms.automatic_capture_at_fulfillment == false %}
            <td class="customer-info__item">
              <h4>Payment</h4>
              {% if payment_terms.type == 'receipt' and payment_terms.next_payment.due_at == nil %}
                {% assign due_date = 'now' %}
              {% else %}
                {% assign due_date = payment_terms.next_payment.due_at | default: nil %}
              {% endif %}
              {% if payment_terms.type == 'fulfillment' and payment_terms.next_payment.due_at == nil %}
                <p>{{ payment_terms.translated_name }}</p>
              {% else %}
                <p>{{ payment_terms.translated_name }}: Due {{ due_date | date: format: 'date' }}</p>
              {% endif %}
            {% endif %}
            </td>
          </tr>
          <tr>
            {% if shipping_method %}
              <td class="customer-info__item">
                <h4>Shipping method</h4>
                <p>{{ shipping_method.title }}<br/>{{ shipping_method.price | money }}</p>
              </td>
            {% endif %}
          </tr>
        </table>

            </td>
          </tr>
        </table>
      </center>
    </td>
  </tr>
</table>
      {% endif %}

      <table class="row footer">
  <tr>
    <td class="footer__cell">
      <center>
        <table class="container">
          <tr>
            <td>
              
              <p class="disclaimer__subtext">If you have any questions, reply to this email or contact us at <a href="mailto:{{ shop.email }}">{{ shop.email }}</a></p>
            </td>
          </tr>
        </table>
      </center>
    </td>
  </tr>
</table>

<img src="{{ 'notifications/spacer.png' | shopify_asset_url }}" class="spacer" height="1" />

    </td>
  </tr>
</table>
</body>
</html>
`